class GaugeResultVM extends BaseResultVM {
    dataTable: [];
    
    value: number
    targetValue: number;

    metric: GaugeColumnInfo;
    target: GaugeColumnInfo;

    currencyCode: string;

    gaugeSettings: DevExpress.viz.dxCircularGauge.Properties;
    gaugeComponent: DevExpress.viz.dxCircularGauge;

    constructor(data) {
        super(data);

        this.dataTable = data.dataTable;
        this.value = data.value;
        this.targetValue = data.targetValue;
        this.metric = new GaugeColumnInfo(data.metric);
        this.target = new GaugeColumnInfo(data.target);
        this.currencyCode = data.currencyCode;
    }
}
class GaugeColumnInfo {
    index: number;
    queryName: string;
    autoGrouping: AutoGroupingEnum;
    groupingType: GroupingTypeEnum;
    dataType: DataTypeEnum;

    accountingStyle: boolean;
    decimalPlaces: number;
    metricFormat: FieldFormatEnum;

    constructor(data) {
        this.index = data.index;
        this.queryName = data.queryName;
        this.autoGrouping = data.autoGrouping;
        this.groupingType = data.groupingType;
        this.dataType = data.dataType;
        this.accountingStyle = data.accountingStyle;
        this.decimalPlaces = data.decimalPlaces;
        this.metricFormat = data.metricFormat;
    }
}